import React from 'react';
import { Typography, CardMedia } from '@material-ui/core';

const data = (
<Typography component="div">
  <h1>Robotics</h1>

  <h2>Background</h2>
  <p>
    This project is part of a 3rd-year course at Imperial. This course taught me how to use Machine Learning to help the robot navigate in real-world, using Gaussian Distribution to model uncertainties. And use Bayesian Probabilistic Inference to help robot determine its location in a known map. <br/><br/>

    A competition is held with a task of navigating in a known map, finding three randomly placed bottles, touching them and returning to the start point accurately. Each team is given a Raspberry Pi, three motors and one ultrasound sensor.
  </p>

  <h2>A Beard Well Lathered is Half Shaved</h2>
  I was chosen to be the leader due to my enthusiasm and project management skills. I understand the importance of good infrastructure for a large team and rapid development. I spend a few days to set up the Raspberry Pi with account for each member and git repository with branches and rules to protect them. By the end of the set up, each member can ssh to the Raspberry Pi, perform code modification independently and run the run test without any hassle.  <br/><br/>

  I also chose to use OOP to wrap low-level implementation, providing a high-level abstraction. Enabling rapid prototyping with various strategies at the same time which becomes the keystone to our success.

  <h2>Monte Carlo Particle Filter</h2>
  The core of our software is the Monte Carlo Particle Filter which enables the Probabilistic Localization. Our software stores a bag of tuples which represent the possible locations of the robot. When the robot performs an action, particles are spread out using Gaussian Distribution. The Monte Carlo Particle Filter uses sampling and Bayesian Probabilistic Inference to help converge particles to help robot determine its location.<br/><br/>

  <img src={require('./filter.gif')} width="400" /><br/>

  The gif above shows how our particle filter performs when started by uniformly distributed around (180,42), but getting sonar reading as if it is at (190,42). Note that since the measurement was only taken in the x-direction, the particles converge to a line with x position being 190, but uncertain about its y position.


  <h2>Think Outside of Box</h2>
  A constrain of the competition is the robot need to be able to fit inside a box, limiting its dimension. I come up with the idea to design a foldable device that would deploy after the robot starts navigating. The video below shows how it works and you can hear the cheers from the impressed professor in the background. <br/><br/>


  <iframe width="560" height="315" src="https://www.youtube.com/embed/h3l0QkhQjNw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />

  <h2>Team Photo</h2>

  <img src={require('./team.png')} width="600" /><br/>

  For more technical information or to view the source code, please click the "Github" button below.

</Typography>
)
export default data